import { css } from '@design.estate/dees-element';

export const viewerStyles = css`
  :host {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-family: var(--dees-font-family);
  }

  .viewer-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: var(--dees-color-code-block-bg);
  }

  .zoom-level {
    font-size: 13px;
    font-weight: 500;
    min-width: 48px;
    text-align: center;
    color: var(--dees-color-text-secondary);
    cursor: pointer;
  }

  .image-area {
    min-height: 0;
    touch-action: none;
    flex: 1;
    position: relative;
    overflow: hidden;
    cursor: var(--image-cursor, default);
  }

  .checkerboard {
    position: absolute;
    inset: 0;
    background-image:
      linear-gradient(45deg, var(--dees-color-border-subtle) 25%, transparent 25%),
      linear-gradient(-45deg, var(--dees-color-border-subtle) 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, var(--dees-color-border-subtle) 75%),
      linear-gradient(-45deg, transparent 75%, var(--dees-color-border-subtle) 75%);
    background-size: 16px 16px;
    background-position: 0 0, 0 8px, 8px -8px, -8px 0px;
    opacity: 0.3;
  }

  .image-wrapper {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(var(--pan-x, 0px), var(--pan-y, 0px)) scale(var(--zoom, 1));
    transition: transform var(--dees-transition-default) var(--dees-ease-out);

  }

  .image-wrapper.dragging { transition: none; }

  .image-wrapper img {
    max-width: 100%;
    max-height: 100%;
    object-fit: var(--image-fit, contain);
    user-select: none;
    -webkit-user-drag: none;
  }

  .image-wrapper img.actual {
    max-width: none;
    max-height: none;
    object-fit: none;
  }

  .loading-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: color-mix(in srgb, var(--dees-color-bg-primary) 75%, transparent);
  }

  .loading-spinner {
    width: 32px;
    height: 32px;
    border: 3px solid var(--dees-color-border-default);
    border-top-color: var(--dees-color-link);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  .error-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: var(--dees-color-text-muted);
  }

  .error-overlay .error-icon {
    color: var(--dees-color-text-error);
    font-size: 32px;
  }

  .error-text {
    font-size: 13px;
  }

  .image-info {
    font-size: 11px;
    color: var(--dees-color-text-muted);
    padding: 0 4px;
  }

.image-area { min-height: 0; } .image-wrapper.dragging { transition: none; }
`;
